export const orange = '#F06060';
export const lightOrange = '#FFF3EE';
export const blue = '#57BEFF';
export const lightBlue = '#A9C9FF';
export const purple = '#5128AA'; // @FIXME-RT: We'll want to consolidate this with `darkPurple`
export const pink = '#CC94EC';
export const darkPurple = '#5128AA';
export const purpleLighten20 = '#7453BB';
export const purpleLighten80 = '#977ECC';
export const lightViolet = '#DED7FF';
export const red = '#EC6545';
export const primaryRed = '#FF5A60';
export const yellow = '#F9D33D';
export const black = 'rgba(0, 0, 0, 0.87)';
export const lightYellow = '#FFFAA4';
export const lighterYellow = '#FFFEDD';
export const gray = '#555566';
export const gray2 = '#999';
export const gray3 = '#727272';
export const gray4 = '#B9B9B9';
export const gray5 = '#B6BDBD';
export const gray6 = '#CCCCCC';
export const lightGray = 'rgba(0, 0, 0, 0.12)';
export const lighterGray = '#FAFAFC';
export const mediumGray = '#EBEEF0';
export const blueGray = '#8385BC';
export const blueGrayLight = '#E3E4F0';
export const dark = '#151515';
export const teal = '#008080';
export const green = '#27AE60';
export const white = '#FFFFFF';
export const lightGreen = '#E8FFF3';
export const lightRed = '#FFE9E9';
// @TODO make it customisable
export const brand = 'rgb(53, 110, 246)';
export const brandDarkened = 'rgb(0, 68, 229)';
export const brandTint = 'rgba(53, 110, 246, 0.06)';
export const greenTint = '#EBF8EC';
export const yellowTint = '#FFFBF5';
export const redTint = '#FFF2F2';
export const blackish = 'rgba(0, 0, 0, 0.87)';
export const grayish = 'rgba(0, 0, 0, 0.54)';
export const purpleish = 'rgba(119, 21, 245, 0.04)';
export const statusSuccess = '#E8FFF3';
export const statusError = '#FFE9E9';
export const statusWarning = '#FFE0B2';
export const statusNeutral = '#FFF2DC';
export const statusDisabled = '#F3F3F3';
export const statusTextSuccess = '#23A461';
export const statusTextError = '#EC6545';
export const statusTextWarning = '#E65100';
export const statusTextNeutral = '#DD941B';
export const statusTextDisabled = '#9C9B9A';
export const statusCompleted = '#E3E4FE';
export const statusTextCompleted = '#5E64FF';
export const statusPending = '#E5EDF1';
export const statusTextPending = '#959492';
export const lightGreenText = '#23A461';
export const lightRedText = '#EC6545';
export const primaryBlue = darkPurple; // @FIXME-AS: Rename this to `primary` _at some point_
export const lightPurple = '#F1E9FB';
